// LOADER ************************************************************************************
/*********************************************************************************************
* Add a loading state to the specified button.
	* 
	* @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
*/
const mmLoadThis = (elem) => elem.classList.add('mm-loading');

// MEGAMENU **********************************************************************************
/*********************************************************************************************
* Hide specified elements and show the specified element.
	* 
	* @param {string} classElemsToHide - The CSS selector for the elements to hide.
	* @param {string} classElemToShow - The CSS selector for the element to show.
*/
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
    document.querySelectorAll(classElemsToHide).forEach(elem => elem.style.display = 'none');
    document.querySelector(classElemToShow).style.display = 'grid';
};

/*********************************************************************************************
* Adjust the position of the mega menu based on the header height.
	*
*/
const getMegaMenuPosition = () => {
    const header = document.querySelector('[data-mm-header]');
    if (!header) return;

    const headerHeight = header.offsetHeight;
    document.querySelectorAll('[data-megamenulink]').forEach(menuElem => {
        const megaMenu = menuElem.nextElementSibling;
        if (megaMenu?.hasAttribute('data-megamenu')) {
            megaMenu.style.top = `${headerHeight - 1}px`;
        }
    });
};

// PRODUCT CARD *****************************************************************************
/*********************************************************************************************
* Setup Splide carousels for product cards.
	*
*/
function mmSetupProductCardsSplides() {
    let ids = '.splide-product-card';
    let splideElems = document.querySelectorAll(ids);
    if (splideElems) {
        splideElems.forEach(function(elem) {
            var splide = new Splide( elem, {
                type   : 'slide',
                arrows: true,
                pagination: false,
                gap: 0,
                perPage: 1,
                breakpoints: {
                    768: {
                        arrows: false
                    }
                }
            })
            var bar = splide.root.querySelector( '.my-carousel-progress-bar' );
            if (bar) {
                splide.on( 'mounted move', function () {
                    var end  = splide.Components.Controller.getEnd() + 1;
                    var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                    bar.style.width = String( 100 * rate ) + '%';
                } );
            }
            splide.mount();
        })
    }
}

/*********************************************************************************************
* Format price for display in product card popup.
	*
	* @param {string|number} price - Price in cents
*/
function formatPrice(price) {
    const priceNum = parseInt(price);
    return (priceNum / 100).toFixed(2).replace('.', ',') + '€';
}

/*********************************************************************************************
* Reload product card forms after content change.
	*
	* @param {HTMLElement} cardWrapper - The product card wrapper element
*/
function mmReloadSpecificProductCardFroms(cardWrapper) {
    // Initialize size selectors in popup
    const sizeSelectors = cardWrapper.querySelectorAll('[data-size-selector]');
    sizeSelectors.forEach(sizeGrid => {
        const radioButtons = sizeGrid.querySelectorAll('.mm-size-radio');
        const ctaButton = cardWrapper.querySelector('.mm-popup-add-to-cart');
        const ctaPrice = ctaButton?.querySelector('.mm-cta-price');
        
        radioButtons.forEach(radio => {
            radio.addEventListener('change', function() {
                // Remove mm-checked class from all radios in this size grid
                radioButtons.forEach(r => r.classList.remove('mm-checked'));
                
                // Add mm-checked class to the selected radio
                if (this.checked) {
                    this.classList.add('mm-checked');
                    
                    if (ctaPrice) {
                        const price = this.dataset.variantPrice;
                        const isAvailable = this.dataset.variantAvailable === 'true';
                        
                        // Update price in CTA
                        if (price) {
                            ctaPrice.textContent = `\u00A0— ${formatPrice(price)}`;
                        }
                        
                        // Update CTA availability
                        if (ctaButton) {
                            if (isAvailable) {
                                ctaButton.disabled = false;
                                ctaButton.classList.remove('mm-disabled');
                            } else {
                                ctaButton.disabled = true;
                                ctaButton.classList.add('mm-disabled');
                            }
                        }
                    }
                }
            });
            
            // Initialize the mm-checked class based on current state
            if (radio.checked) {
                radio.classList.add('mm-checked');
            }
        });
    });
    
    // Initialize popup add to cart buttons
    const popupAddToCartButtons = cardWrapper.querySelectorAll('.mm-popup-add-to-cart');
    popupAddToCartButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            if (this.disabled) return;
            
            // Find selected variant
            const sizeGrid = cardWrapper.querySelector('[data-size-selector]');
            const selectedRadio = sizeGrid?.querySelector('.mm-size-radio:checked');
            
            if (selectedRadio) {
                const variantId = selectedRadio.value;
                
                // Add loading state
                this.classList.add('mm-loading');
                this.disabled = true;
                
                console.log('Adding to cart from popup:', variantId);
                
                // Use existing cart function if available
                if (typeof mmAddProductToCart === 'function') {
                    mmAddProductToCart(variantId, {openCart: true});
                } else {
                    console.log('mmAddProductToCart function not found');
                }
                
                // Remove loading state
                setTimeout(() => {
                    this.classList.remove('mm-loading');
                    this.disabled = false;
                }, 1000);
            }
        });
    });
    
    // Reinitialize legacy size selector forms in popup (for compatibility)
    const sizeForms = cardWrapper.querySelectorAll('.mm-size-form, .mm-single-form');
    sizeForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const variantId = form.querySelector('input[name="id"]').value;
            const button = form.querySelector('button[type="submit"]');
            
            // Add loading state
            button.classList.add('mm-loading');
            button.disabled = true;
            
            // Add to cart logic here - integrate with existing cart system
            console.log('Adding to cart from popup:', variantId);
            
            // Use existing cart function if available
            if (typeof mmAddProductToCart === 'function') {
                mmAddProductToCart(variantId, {openCart: true});
                button.classList.remove('mm-loading');
                button.disabled = false;
            } else {
                // Fallback - simulate cart addition
                setTimeout(() => {
                    button.classList.remove('mm-loading');
                    button.disabled = false;
                    console.log('Added to cart successfully');
                }, 1000);
            }
        });
    });
    
    // Reinitialize standalone strip buttons
    const stripButtons = cardWrapper.querySelectorAll('.mm-strip-btn');
    stripButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            if (button.disabled) return;
            
            e.preventDefault();
            
            // Add loading state
            button.classList.add('mm-loading');
            button.disabled = true;
            
            // Get variant ID from closest form or data attribute
            const form = button.closest('form');
            let variantId = null;
            
            if (form) {
                const hiddenInput = form.querySelector('input[name="id"]');
                if (hiddenInput) {
                    variantId = hiddenInput.value;
                }
            } else {
                variantId = button.dataset.variantId;
            }
            
            if (variantId) {
                console.log('Adding to cart from strip button:', variantId);
                
                // Use existing cart function if available
                if (typeof mmAddProductToCart === 'function') {
                    mmAddProductToCart(variantId, {openCart: true});
                }
            }
            
            // Remove loading state
            setTimeout(() => {
                button.classList.remove('mm-loading');
                button.disabled = false;
            }, 1000);
        });
    });
    
    // Reinitialize Klaviyo back-in-stock triggers
    const klaviyoTriggers = cardWrapper.querySelectorAll('.klaviyo-bis-trigger');
    klaviyoTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            const variantId = trigger.dataset.variant;
            console.log('Klaviyo back-in-stock triggered for variant:', variantId);
            
            // Integrate with existing Klaviyo system if available
            if (typeof window.klaviyo !== 'undefined') {
                // Use existing Klaviyo integration
                console.log('Opening Klaviyo modal for variant:', variantId);
            }
        });
    });
    
    // Reinitialize other forms if needed
    const otherForms = cardWrapper.querySelectorAll('form[data-type="add-to-cart-form"]:not(.mm-size-form):not(.mm-single-form)');
    otherForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            console.log('Adding to cart:', form.querySelector('input[name="id"]').value);
        });
    });
}

/*********************************************************************************************
* Change product color in product card by fetching card view.
	*
	* @param {HTMLElement} button - The color button element clicked
*/
function mmProductCardChangeColor(button, event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    
    console.log('Color change clicked');
    const cardWrapper = button.closest('.mm-product-card-wrapper');
    const productHandle = button.dataset.productHandle;
    
    // Check if we're on mobile and modal is open
    const oldProductCard = cardWrapper.querySelector('.mm-product-card');
    const isMobileModalOpen = oldProductCard && oldProductCard.classList.contains('mm-pc-active');
    const overlayElement = cardWrapper.querySelector('.mm-pc-mobile-overlay');
    const isOverlayVisible = overlayElement && overlayElement.style.display !== 'none';
    const isMobile = window.innerWidth <= 768;
    
    console.log('Modal state check:');
    console.log('- isMobile:', isMobile, '(width:', window.innerWidth, ')');
    console.log('- oldProductCard:', oldProductCard);
    console.log('- isMobileModalOpen:', isMobileModalOpen);
    console.log('- overlayElement:', overlayElement);
    console.log('- isOverlayVisible:', isOverlayVisible);
    console.log('- overlayElement.style.display:', overlayElement?.style.display);
    
    if (isMobile && isMobileModalOpen && isOverlayVisible) {
        console.log('Mobile modal open - synchronizing both cards');
        
        // Close current modal
        oldProductCard.classList.remove('mm-pc-active');
        if (overlayElement) {
            overlayElement.style.display = 'none';
        }
        document.body.style.overflow = '';
        
        // Fetch new product data
        console.log('Fetching new product data for:', productHandle);
        fetch(`/products/${productHandle}?view=card`)
            .then(res => res.text())
            .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const newProductCard = tempDiv.querySelector('.mm-product-card');
                
                if (newProductCard) {
                    // 1. Update the current active card (where modal was open)
                    console.log('1. Updating current active card');
                    const currentClone = newProductCard.cloneNode(true);
                    
                    // Generate unique IDs for current card
                    const currentUniqueId = `active-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
                    const currentRadios = currentClone.querySelectorAll('.mm-size-radio');
                    const currentLabels = currentClone.querySelectorAll('.mm-size-label');
                    
                    currentRadios.forEach((radio, index) => {
                        const newId = `size-${currentUniqueId}-${index}`;
                        radio.id = newId;
                        radio.name = `size-${currentUniqueId}`;
                        if (currentLabels[index]) {
                            currentLabels[index].setAttribute('for', newId);
                        }
                    });
                    
                    cardWrapper.innerHTML = "";
                    cardWrapper.appendChild(currentClone);
                    
                    // 2. Also update the existing card in the grid for this product
                    console.log('2. Updating existing grid card for same product');
                    const existingTargetCard = document.querySelector(`[data-product-handle="${productHandle}"].mm-product-card:not(:first-child)`);
                    if (existingTargetCard) {
                        const existingWrapper = existingTargetCard.closest('.mm-product-card-wrapper');
                        if (existingWrapper && existingWrapper !== cardWrapper) {
                            const gridClone = newProductCard.cloneNode(true);
                            existingWrapper.innerHTML = "";
                            existingWrapper.appendChild(gridClone);
                            mmReloadSpecificProductCardFroms(existingWrapper);
                            console.log('Updated existing grid card');
                        }
                    }
                    
                    // Select first available size and reinitialize current card
                    const domSizeRadios = cardWrapper.querySelectorAll('.mm-size-radio');
                    const firstAvailableRadio = Array.from(domSizeRadios).find(radio => !radio.disabled);
                    if (firstAvailableRadio) {
                        firstAvailableRadio.checked = true;
                        firstAvailableRadio.classList.add('mm-checked');
                    }
                    
                    mmReloadSpecificProductCardFroms(cardWrapper);
                    
                    // Reinitialize mobile modal trigger
                    const mobileTrigger = cardWrapper.querySelector('.mm-pc-size-popup-mobile-trigger');
                    if (mobileTrigger) {
                        mobileTrigger.onclick = function(e) {
                            mmOpenProductCardMobileModal(this, e);
                        };
                    }
                    
                    // Reopen modal
                    setTimeout(() => {
                        const updatedModal = cardWrapper.querySelector('.mm-product-card');
                        const updatedOverlay = cardWrapper.querySelector('.mm-pc-mobile-overlay');
                        
                        if (updatedModal && updatedOverlay) {
                            updatedModal.classList.add('mm-pc-active');
                            updatedOverlay.style.display = 'block';
                            document.body.style.overflow = 'hidden';
                            console.log('Reopened modal after synchronization');
                        }
                    }, 100);
                }
            })
            .catch(error => {
                console.error('Error synchronizing cards:', error);
            });
        return;
    }
    
    // Desktop behavior or mobile without modal - synchronize both cards
    console.log('Using desktop behavior - synchronizing both cards for:', productHandle);
    fetch(`/products/${productHandle}?view=card`)
        .then(res => res.text())
        .then(html => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const newProductCard = tempDiv.querySelector('.mm-product-card');
            
            if (!newProductCard) return;

            // 1. Update the current card (where color was clicked)
            console.log('1. Updating current card in desktop');
            const currentClone = newProductCard.cloneNode(true);
            
            // Generate unique IDs for desktop too to avoid conflicts
            const desktopUniqueId = `desktop-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
            const desktopRadios = currentClone.querySelectorAll('.mm-size-radio');
            const desktopLabels = currentClone.querySelectorAll('.mm-size-label');
            
            console.log(`Desktop: Updating ${desktopRadios.length} radio IDs with prefix: ${desktopUniqueId}`);
            
            desktopRadios.forEach((radio, index) => {
                const newId = `size-${desktopUniqueId}-${index}`;
                radio.id = newId;
                radio.name = `size-${desktopUniqueId}`;
                if (desktopLabels[index]) {
                    desktopLabels[index].setAttribute('for', newId);
                }
            });
            
            const newSplide = currentClone.querySelector('.splide');
            if (newSplide) {
                new Splide(newSplide, {
                    type: 'slide',
                    arrows: true,
                    pagination: false,
                    gap: 0,
                    perPage: 1
                }).mount();
            }

            cardWrapper.innerHTML = "";
            cardWrapper.appendChild(currentClone);
            
            // Select first available size by default
            const currentDomRadios = cardWrapper.querySelectorAll('.mm-size-radio');
            const firstAvailableRadio = Array.from(currentDomRadios).find(radio => !radio.disabled);
            if (firstAvailableRadio) {
                firstAvailableRadio.checked = true;
                firstAvailableRadio.classList.add('mm-checked');
                console.log('Desktop: Selected first available size:', firstAvailableRadio.id);
            }
            
            mmReloadSpecificProductCardFroms(cardWrapper);
            
            // 2. Also update any existing card in the grid for this same product
            console.log('2. Updating existing grid card for same product in desktop');
            const allTargetCards = document.querySelectorAll(`[data-product-handle="${productHandle}"].mm-product-card`);
            
            allTargetCards.forEach(targetCard => {
                const targetWrapper = targetCard.closest('.mm-product-card-wrapper');
                if (targetWrapper && targetWrapper !== cardWrapper) {
                    console.log('Found existing card to update:', targetCard);
                    const gridClone = newProductCard.cloneNode(true);
                    
                    const gridSplide = gridClone.querySelector('.splide');
                    if (gridSplide) {
                        new Splide(gridSplide, {
                            type: 'slide',
                            arrows: true,
                            pagination: false,
                            gap: 0,
                            perPage: 1
                        }).mount();
                    }
                    
                    targetWrapper.innerHTML = "";
                    targetWrapper.appendChild(gridClone);
                    mmReloadSpecificProductCardFroms(targetWrapper);
                    console.log('Updated existing grid card in desktop');
                }
            });
        });
}

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
* Show background filter.
	*
*/
const showBgFilter = (zIndex) => {
    const filter = document.querySelector('[data-filter]');
    if (!filter) return;
		
	filter.classList.add("active");
    if (zIndex) filter.style.zIndex = zIndex;
}

/*********************************************************************************************
* Hide background filter.
	*
*/
const hideBgFilter = () => {
    const filter = document.querySelector('[data-filter]');
    if (!filter) return;
		
	setTimeout(() => filter.style.removeProperty('z-index'), 200);
    filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
* Open external links in a new tab unless it's the consent modale.
	*
*/
const externalLink = () => {
    document.querySelectorAll('a:not(.consent-wrapper)').forEach(link => {
        if (link.hostname !== window.location.hostname) {
            link.target = '_blank';
            link.rel = 'noreferrer noopener';
        }
    });
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
* Toggle the mobile menu.
	*
*/
const mmMobileMenu = () => {
	const menu = document.querySelector('.mm-menu-mobile');
	if (!menu.classList.contains("mm-menu-open")) {
		menu.classList.add("mm-menu-open");
		document.querySelector('html').classList.add('stop-scrolling');
	} else {
		menu.classList.remove("mm-menu-open");
		document.querySelector('html').classList.remove('stop-scrolling');
	}
}

/*********************************************************************************************
* Close the mobile menu.
	*
*/
const mmCloseMobileMenu = (keepFilterActive = false) => {
    if (window.innerWidth > 768) return;

    const elements = {
        header: document.querySelector("header"),
        icon: document.querySelector("[data-header-burger]"),
        mobileMenu: document.querySelector("[data-menu-mobile]"),
        html: document.querySelector("html")
    };

    if (Object.values(elements).some(el => !el)) return;

    const { header, icon, mobileMenu, html } = elements;

    [header, icon, mobileMenu].forEach(el => el.classList.remove("mm-open"));
    html.classList.remove("stop-scrolling");

    if (!keepFilterActive) hideBgFilter();
}

/*********************************************************************************************
* Show the next sub-menu in the mobile menu.
	* 
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
const mmMobileMenuShowNext = (elemToShowClass) => {
    document.querySelector(elemToShowClass)?.classList.add('mm-mobile-menu-elem-slided');
};

/*********************************************************************************************
* Show the previous sub-menu in the mobile menu.
	* 
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
const mmMobileMenuShowPrev = (elemToShowClass) => {
    document.querySelector(elemToShowClass)?.classList.remove('mm-mobile-menu-elem-slided');
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
* Handle dropdown behavior.
	*
*/
const handleDropdown = () => {
    const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	// Open first dropdown by default
	if (dropWrappers.length > 0) {
		dropWrappers[0].classList.add('active');
		dropWrappers[0].nextElementSibling.style.maxHeight = dropWrappers[0].nextElementSibling.scrollHeight + 'px';
	}

    dropWrappers.forEach((item) => {
        item.addEventListener('click', function() {
			console.log('item')
            dropWrappers.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
                }
            });

            this.classList.toggle('active');
            const content = this.nextElementSibling;

            if (content) {
                content.style.maxHeight = this.classList.contains('active') ? `${content.scrollHeight}px` : null;
            }
        });
    });
};

// SEARCH ************************************************************************************
/*********************************************************************************************
* Show the search bar and related UI changes.
	* 
	* @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
*/
const mmShowSearch = () => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    html.classList.add('stop-scrolling');
    search.classList.add('mm-open');
    showBgFilter();

    setTimeout(() => searchInput.focus(), 1000);

    document.getElementById('predictive-search')?.addEventListener("touchstart", () => {
        setTimeout(() => searchInput.blur(), 500);
    });
}

/*********************************************************************************************
* Hide the search bar and revert UI changes.
	* 
	* @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
*/
const mmHideSearch = (keepFilterActive = false) => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    html.classList.remove('stop-scrolling');
    search.classList.remove('mm-open');
    if (!keepFilterActive) hideBgFilter();
    
    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input'));
}

/*********************************************************************************************
	* Initialize parallax effect for slide images.
	*
*/
const mmInitParallax = () => {
    const images = document.querySelectorAll(".mm-slide-image");
    if (!images.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const slideImage = entry.target;
                const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
                if (!covers.length) return;

                covers.forEach(cover => {
                    gsap.to(cover, {
                        yPercent: 30,
                        ease: "none",
                        scrollTrigger: {
                            trigger: slideImage,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true
                        }
                    });
                });

                observer.unobserve(slideImage);
            }
        });
    }, {
        rootMargin: "0px 0px 200px 0px"
    });

    images.forEach(image => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
            const source = video.querySelector('source');
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

            video.load();
            video.play().catch(err => console.warn('Auto-play failed:', err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
            video.pause();
            video.currentTime = 0;
            video.dataset.loaded = "false";
        }
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || 
		(isDesktop && !isMobile) || 
		(isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
* Set the document height CSS variable to the current window height.
	*
*/
const documentHeight = () => {
    document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

/*********************************************************************************************
* Custom element for product recommendations
	*
*/
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        // Réinitialiser la wishlist pour les nouvelles cartes de produits
                        if (window.wishlistManager) {
                            window.wishlistManager.initButtons();
                        }
                    } else {
                        const parentElement = this.closest('.mm-section');
                        if (parentElement) {
                            parentElement.style.display = 'none';
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre
            initializeFunction(splideElem, section);
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let scrollCounter = 0;

    splideElem.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        e.preventDefault();

        scrollCounter++;

        if (scrollCounter >= 12) {
            scrollCounter = 0;

            if (e.deltaX < 0) {
                splideInstance.go('<');
            } else if (e.deltaX > 0) {
                splideInstance.go('>');
            }
        }
    });
}

// DOM ***************************************************************************************
/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener('DOMContentLoaded', () => {
    getMegaMenuPosition();
    externalLink();
    handleDropdown();
    documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
	mmSetupProductCardsSplides();
	
	// Initialize product card forms
	document.querySelectorAll('.mm-product-card-wrapper').forEach(wrapper => {
		mmReloadSpecificProductCardFroms(wrapper);
	});
});

/*********************************************************************************************
* Resized Listenner
	*
*/
window.addEventListener('resize', () => {
    getMegaMenuPosition();
    documentHeight();
});

/*********************************************************************************************
* Open mobile modal for product card size selection
	*
	* @param {HTMLElement} trigger - The trigger element (plus icon)
	* @param {Event} event - The click event
*/
function mmOpenProductCardMobileModal(trigger, event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    
    const productCard = trigger.closest('.mm-product-card');
    if (!productCard) {
        console.log('No product card found');
        return;
    }
    
    const productCardWrapper = productCard.closest('.mm-product-card-wrapper');
    if (!productCardWrapper) {
        console.log('No product card wrapper found');
        return;
    }
    
    // Add active class to show popup on mobile
    productCard.classList.add('mm-pc-active');
    
    // Show overlay
    const overlay = productCardWrapper.querySelector('.mm-pc-mobile-overlay');
    if (overlay) {
        overlay.style.display = 'block';
    }
    
    // Find the popup to show
    const popup = productCard.querySelector('.mm-pc-size-popup');
    if (popup) {
        popup.style.opacity = '1';
        popup.style.visibility = 'visible';
        popup.style.pointerEvents = 'all';
    }
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    console.log('Mobile popup opened for product');
}

/*********************************************************************************************
* Close mobile modal for product card
	*
	* @param {HTMLElement} element - The element that triggered the close (overlay or close button)
*/
function mmCloseProductCardMobileModal(element) {
    const productCardWrapper = element.closest('.mm-product-card-wrapper');
    if (!productCardWrapper) return;
    
    const productCard = productCardWrapper.querySelector('.mm-product-card');
    if (productCard) {
        // Remove active class
        productCard.classList.remove('mm-pc-active');
        
        // Hide popup
        const popup = productCard.querySelector('.mm-pc-size-popup');
        if (popup) {
            popup.style.opacity = '0';
            popup.style.visibility = 'hidden';
            popup.style.pointerEvents = 'none';
        }
    }
    
    // Hide overlay
    const overlay = productCardWrapper.querySelector('.mm-pc-mobile-overlay');
    if (overlay) {
        overlay.style.display = 'none';
    }
    
    // Restore body scroll
    document.body.style.overflow = '';
}
